import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReduxModal from 'Common/Components/ReduxModal';
import { MODAL_AGENT_CREATE, MODAL_AGENT_TOKEN, MODAL_CLOUD_AGENT_CREATE } from 'store/modals/modals';
import { closeModal, openModal } from 'store/modals/actions';
import TokenButton from './components/TokenButton';
import { Wrapper, RightWrapper } from './styled';
import Token from './components/TokenButton/components/Token';
import CreateButton from './components/CreateButton';
import CreateAgentMenu from '../CreateNewAgent';
import { EEFeatureSlot } from 'Common/ee/EEFeatureSlot';
import {
  PERMISSION_TYPES, FEATURE_AGENTS, FEATURE_CLOUD_AGENTS, FEATURE_AGENT_TOKEN
} from 'Hooks/usePermission/permissions';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { RUN_STATUS_LOG } from '../Tabs/constants';
import RunStatusLog from './components/RunStatusLog';
import ConfigureButton from './components/ConfigureButton';
import DeleteButton from './components/DeleteButton';
import DeletionModal from './components/DeletionModal';
import { removeAgent, removeSelectedAgents, resetWizard, setPageCloudAgents, setPageUserAgents } from 'store/Agents/actions';
import Pagination from 'Common/Components/Pagination';
import { selectPage, selectRowsPerPageGrid, selectRowsPerPageList, selectShowGridView } from 'store/Filters/selectors';
import { selectAgentCount, selectAgentsSelected, selectCloudAgentCount } from 'store/Agents/selectors';

const ActionBar = ({ selectedTab, showCloudAgents }) => {
  const dispatch = useDispatch();

  const [agentToDelete, setAgentToDelete] = useState(null);
  const [showDeletionModal, setShowDeletionModal] = useState(false);

  const entity = showCloudAgents ? 'cloudAgents' : 'agents';
  const showGridView = useSelector((state) => selectShowGridView(entity, state));
  const page = useSelector((state) => selectPage(entity, state));
  const rowsList = useSelector((state) => selectRowsPerPageList(entity, state));
  const rowsGrid = useSelector((state) => selectRowsPerPageGrid(entity, state));
  const rowsPerPage = showGridView ? rowsGrid : rowsList;
  const userAgentsCount = useSelector(selectAgentCount);
  const cloudAgentsCound = useSelector(selectCloudAgentCount);
  const count = entity === 'cloudAgents' ? cloudAgentsCound : userAgentsCount;
  const canCreateRunner = useSelector((state) => selectAllowedByRole(state, FEATURE_AGENTS, PERMISSION_TYPES.CREATE));
  const canCreateCloudAgent = useSelector((state) => selectAllowedByRole(state, FEATURE_CLOUD_AGENTS, PERMISSION_TYPES.CREATE));
  const canSeeToken = useSelector((state) => selectAllowedByRole(state, FEATURE_AGENT_TOKEN, PERMISSION_TYPES.READ));
  const agentsSelected = useSelector(selectAgentsSelected);

  const markToDelete = (agent) => {
    setAgentToDelete(agent);
    setShowDeletionModal(true);
  };

  const cancelDeletion = () => {
    setShowDeletionModal(false);
    setAgentToDelete(null);
  };

  const performDelete = () => {
    setShowDeletionModal(false);
    setAgentToDelete(null);
    if (agentToDelete) {
      dispatch(removeAgent(agentToDelete));
      return;
    }

    if (agentsSelected.length) {
      dispatch(removeSelectedAgents());
    }
  };

  const setPage = (page) => {
    if (showCloudAgents) dispatch(setPageCloudAgents(page));
    else dispatch(setPageUserAgents(page));
  };

  const onPrev = () => setPage(page - 1);

  const onNext = () => setPage(page + 1);

  const onCloseCreate = () => {
    dispatch(closeModal(MODAL_AGENT_CREATE));
    dispatch(resetWizard());
  };

  const onCloseCloudCreate = () => {
    dispatch(closeModal(MODAL_CLOUD_AGENT_CREATE));
  };

  if (selectedTab === RUN_STATUS_LOG) return <RunStatusLog />;
  return (
    <Wrapper>
      {
        !showCloudAgents &&
        <>
          <CreateButton />
          <TokenButton onClick={ () => dispatch(openModal(MODAL_AGENT_TOKEN)) } />
        </>
      }
      {
        showCloudAgents &&
        <CreateButton
          modalId={ MODAL_CLOUD_AGENT_CREATE }
          labelId="agents.cloudAgents.create.title"
          labelDefault="Add Security Scanner"
          feature={ FEATURE_CLOUD_AGENTS }
        />
      }
      <ConfigureButton />
      { !showCloudAgents && <DeleteButton markToDelete={ markToDelete } /> }
      <RightWrapper>
        <Pagination offset={ page } limit={ rowsPerPage } total={ count } onPrev={ onPrev } onNext={ onNext } />
      </RightWrapper>
      <ReduxModal id={ MODAL_AGENT_TOKEN }>
        { canSeeToken && <Token /> }
      </ReduxModal>
      <ReduxModal id={ MODAL_AGENT_CREATE }>
        { canCreateRunner && <CreateAgentMenu onClose={ onCloseCreate } /> }
      </ReduxModal>
      <ReduxModal id={ MODAL_CLOUD_AGENT_CREATE }>
        { canCreateCloudAgent &&
          <EEFeatureSlot featureKey="add-scanner-modal" render={ (AddScanner) => <AddScanner onClose={ onCloseCloudCreate } /> } />
        }
      </ReduxModal>
      <DeletionModal isOpen={ showDeletionModal } agentToDelete={ agentToDelete } agentsSelected={ agentsSelected } onAccept={ performDelete } onClose={ cancelDeletion } />
    </Wrapper>
  );
};
export default ActionBar;
